<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-11-27 09:32:29
 * @LastEditors: caizexin caizexin@kjgb.net
 * @LastEditTime: 2025-05-28 17:22:52
 * @FilePath: \vue-hepha-order\src\views\dealer\DealerList.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div>
        <div class="queryPanel">
            <div class="queryPanel_form" :class="{'queryPanel_form_show': showForm}">
                <Form 
                    :form="queryForm" 
                    @handleSelectChange="handleSelectChange"
                    @handlePressEnter="handlePressEnter"
                    @handleInputClear=handleInputClear
                ></Form>
            </div>
            <div class="queryPanel_btn">
                <!-- <a-button class="form_btn" type="primary" size="mini" @click="handle('search')">{{ $t('base.search') }}</a-button>
                <a-button class="form_btn" type="outline" size="mini" @click="handle('reset')">{{ $t('base.reset') }}</a-button> -->

                <a-dropdown-button size="small" @click="handle('search')">
                    <icon-search size="14" style="marginRight:5px;"/>
                    {{ $t('base.search') }}
                    <template #content>
                        <a-doption @click="handle('reset')">
                            <icon-refresh size="14" style="marginRight:5px;"/>
                            {{ $t('base.reset') }}
                        </a-doption>
                    </template>
                </a-dropdown-button>
                <span class="openBtn" v-if="!showForm" @click="showFormPanel(true)">
                    <icon-down-circle size="14"/>
                    {{ $t('base.open') }}
                </span>
                <span class="openBtn" v-else @click="showFormPanel(false)">
                    <icon-up-circle size="14" />
                    {{ $t('base.close') }}
                </span>
            </div>
        </div>
        <Table 
            :table="table"
            @changePage="changePage"
            @changePageSize="changePageSize"
        >
            <template v-slot:operate>
                <a-button type="primary" size="small" v-permission="'setting.dealer.exportDealer'" :disabled="exporting" @click="handle('exportDealer')">
                    <icon-download size="15" style="marginRight:5px;"/>
                    {{ $t('dealer.exportDealer') }}
                </a-button>
                <a-divider direction="vertical" />
                <a href=" https://dealerorder.hepha.com/#/BecomeDealer" target="_blank" style="color:#fff">
                    <a-button type="primary" size="small" v-permission="'setting.dealer.becomeDealer'">
                        <icon-link size="15" style="marginRight:5px;"/>
                        {{ $t('dealer.becomeDealer') }}
                    </a-button>
                </a>
                
                <!-- <a-button v-permission="'setting.dealer.shareLink'" type="primary" size="small" class="shareLink" :data-clipboard-text="copyShareLink" @click="shareLink">
                    <icon-link :size="15" style="margin-right:5px"/>
                    {{ $t('base.shareLink') }}
                </a-button> 
                <a-popover position="top">
                    <a-button v-permission="'setting.dealer.shareLink'" type="primary" size="small" style="margin-left:15px" @click="shareQrcode">
                        <icon-qrcode :size="15" style="margin-right:5px"/> {{ $t('dealer.qrcode') }}
                    </a-button>
                    <template #content>
                        {{$t('dealer.qrcode')}}
                    </template>
                </a-popover>
                <a-popover :title="t('dealer.copyLinkTipTitle')" position="right">
                    <icon-question-circle v-permission="'setting.dealer.shareLink'" :size="25" style="margin:3px 0 0 10px; vertical-align: bottom;cursor:pointer;"/>
                    <template #content>
                        <p>{{$t('dealer.btnTip')}}</p>
                        <p>{{$t('dealer.btnTip2')}}</p>
                    </template>
                </a-popover> -->
            </template>

            <template v-slot:columns="{ props }"> 
                <div v-if="props.column.key == 'dealer_level'" style="font-size:12px;">
                    <a-tooltip 
                        v-if="props.record.dealer_level != '-'"
                        :content="getFullLevelInfo(props.record)"
                        position="top"
                    >
                        <a-tag 
                            :color="props.record.dealer_level_val == 1? 'green' : props.record.dealer_level_val == 3? 'gray' : props.record.dealer_level_val == 5? 'gold' : props.record.dealer_level_val == 7? 'blue' : 'orange'" 
                            :text="props.record.order_status"
                            class="level-tag-hover"
                        >{{ props.record.dealer_level }}</a-tag>
                    </a-tooltip>
                    <div v-else>-</div>
                </div>
                <div v-if="props.column.key == 'active_flag'" style="font-size:12px;">
                    <a-tag 
                        :color="props.record.active_flag_val == 1? 'green' : 'red'" 
                    >{{ props.record.active_flag }}</a-tag>
                </div>
            </template>

            <template v-slot:tableOperate="{ props }">
                <a-button v-permission="'setting.dealer.setLevel'" class="form_btn" type="primary" status="success" size="mini"  @click="handle('setLevel',props.record)">{{ $t('dealer.setLevel') }}</a-button>
                <a-button v-permission="'setting.dealer.syncErpCode'" class="form_btn" type="primary" status="warning" size="mini" :disabled="props.record.erp_code != '-'" @click="handle('syncErpCode',props.record)">{{ $t('dealer.syncErpCode') }}</a-button>
                <!-- <a-button v-permission="'setting.dealer.preview'" type="primary" size="mini" :disabled="props.record.auto_code !== '-'"  @click="previewFile(props.record.file)">{{ $t('base.previewFile') }}</a-button> -->
                <a-button v-permission="'setting.dealer.edit'" type="primary" size="mini"  @click="handle('edit',props.record)">{{ $t('base.edit') }}</a-button>
                <a-button v-permission="'setting.dealer.detail'" type="primary" size="mini"  @click="handle('detail',props.record)">{{ $t('base.detail') }}</a-button>
                <a-button v-permission="'setting.dealer.reEnter'" type="primary" size="mini"  @click="handle('reEnter',props.record)">{{ $t('dealer.reEnter') }}</a-button>
            </template>
        </Table>

        <!-- 评级 -->
        <a-modal 
            v-model:visible="levelVisible" 
            :width="1300"
            draggable
            :onBeforeOk="beforeLevelOk"
        >
            <template #title>{{ $t('dealer.setDealerLevel') }}</template>
            <div class="dealer-level-container">
                <a-radio-group v-model="level" class="dealer-level-radio-group">
                    <!-- <a-radio value="1" class="radioItem">{{ $t('dealer.bronze') }}</a-radio> -->
                    <!-- <a-radio value="3" class="radioItem">{{ $t('dealer.silver') }}</a-radio> -->
                    <!-- <a-radio value="5" class="radioItem">{{ $t('dealer.gold') }}</a-radio> -->
                    <!-- <a-radio value="7" class="radioItem">{{ $t('dealer.platinum') }}</a-radio> -->
                    <a-radio value="10" class="radioItem">F0/D0</a-radio>
                    <a-radio value="11" class="radioItem">F35/D50</a-radio>
                    <a-radio value="12" class="radioItem">F70/D100</a-radio>
                    <a-radio value="13" class="radioItem">F150/D200</a-radio>
                    <a-radio value="14" class="radioItem">F220/D400</a-radio>
                    <!-- <a-radio value="15" class="radioItem">DG1</a-radio> -->
                    <!-- <a-radio value="16" class="radioItem">DG3</a-radio> -->
                    <!-- <a-radio value="17" class="radioItem">DG5</a-radio> -->
                    <a-radio value="20" class="radioItem">26-DLJB/DCBS400</a-radio>
                    <a-radio value="21" class="radioItem">26-DXXL</a-radio>
                    <a-radio value="22" class="radioItem">26-DV100</a-radio>
                    <a-radio value="23" class="radioItem">26-DV200</a-radio>
                    <a-radio value="24" class="radioItem">26-DV400</a-radio>
                    <a-radio value="25" class="radioItem">26-DG1</a-radio>
                    <a-radio value="26" class="radioItem">26-DG2</a-radio>
                    <a-radio value="27" class="radioItem">26-DG5</a-radio>
                    <a-radio value="28" class="radioItem">26-D0/DB0/DE0/AT0/F0/IT0/N0</a-radio>
                    <a-radio value="29" class="radioItem">26-D50/DB50/DE50AT25/F35/IT25/N25</a-radio>
                    <a-radio value="30" class="radioItem">26-D100/DB100/DE100/AT75/F70/IT75/N75</a-radio>
                    <a-radio value="31" class="radioItem">26-D200/DB200/DE200/AT150/F150/IT150N150</a-radio>
                    <a-radio value="32" class="radioItem">26-D400/DB400/DE400/AT300/F220/IT300/N300</a-radio>
                    <a-radio value="33" class="radioItem">26-N90</a-radio>
                    <a-radio value="34" class="radioItem">26-N150</a-radio>
                    <a-radio value="35" class="radioItem">26-N250</a-radio>
                </a-radio-group>
            </div>
        </a-modal>

        <!-- 编辑经销商信息 -->
        <a-modal 
            v-model:visible="editVisible" 
            width="60%"
            draggable   
            :onBeforeOk="beforeEditOk"
        >
            <template #title>{{ $t('base.edit') }}</template>
                <div v-if="editVisible" style="text-align:center;color:#1e88e5;">
                   <div class="editHead">{{ $t('dealer.companyName') }} ： {{ rowData.company_name }}</div> 
                   <div class="editHead">{{ $t('dealer.erpAutoCode') }} ： {{ rowData.auto_code }}</div> 
                </div>
                <a-divider orientation="center" style="font-weight:600;">{{ $t('base.companyInfo') }}</a-divider>
                <Form 
                    :form="companyForm" 
                ></Form>

                <a-divider orientation="center" style="font-weight:600;">{{ $t('dealer.storeInfo') }}</a-divider>
                <Form 
                    :form="storeForm"
                ></Form>

                <a-divider orientation="center" style="font-weight:600;">{{ $t('dealer.deliveryInfo') }}</a-divider>
                <Form 
                    :form="deliveryForm"
                ></Form>

                <a-divider orientation="center" style="font-weight:600;">{{ $t('dealer.otherInfo') }}</a-divider>
                <Form 
                    :form="otherForm"
                ></Form>
        </a-modal>

        <!-- 编辑经销商其他信息，设置属性 -->
        <a-modal 
            v-model:visible="moreVisible" 
            width="50%"
            draggable
            :mask-closable="false"
            :render-to-body="false"
        >
            <template #title>{{ $t('base.setting') }}</template>
            <Form 
                :form="otherSettingForm"
                @changeRadio="changeRadio"
                @handleInput="handleInput"
            ></Form>

            <template #footer>
                <a-button class="form_btn" @click="reset">{{ $t('base.reset') }}</a-button>
                <a-button class="form_btn" @click="moreVisible = false">{{ $t('base.cancel') }}</a-button>
                <a-button class="form_btn" type="primary" @click="beforeEditOtherOk">{{ $t('base.ok') }}</a-button>
            </template>
        </a-modal>

        <!-- 二维码 -->
        <a-modal 
            v-model:visible="showQrcode" 
            :width="800"
            :hide-cancel="true"
            draggable
            :render-to-body="false"
            @ok="showQrcode = false"
        >
            <template #title>{{ $t('base.qrcode') }}</template>
            <qrcode-vue
                class="qrcode"
                v-if="showQrcode" 
                :value="qrcodeValue" 
                :size="100"
                level="Q" 
            />
            <section class="logo">
                <img src="@/assets/image/index-banner-Icon.webp" width="15"  heigth="15"/>
            </section>
            <p style="color:#aaa;font-weight:bold">{{ $t('dealer.qrcodeTip')}}</p>
            <p style="color:#aaa;font-weight:bold">( {{ $t('dealer.qrcodeTip2')}} )</p>
        </a-modal>

        <!-- 详情 -->
        <Detail :row="rowData" :detailVisible="detailVisible" @handleCancel="handleCancelDrawer"></Detail>
    </div>
</template>

<script setup>
    import { onMounted, reactive, ref, watch, nextTick, h } from 'vue';
    import { useRouter, useRoute } from 'vue-router';
    import { DealerApi } from '@/api/DealerApi.js';
    import { OrderApi } from '@/api/OrderApi.js';
    import { Message, Modal } from '@arco-design/web-vue';
    import Table from '@/components/Table.vue';
    import Form from '@/components/Form.vue';
    import Detail from './Detail.vue';
    import Clipboard from 'clipboard';
    import QrcodeVue from 'qrcode.vue'
    import { DealerListQuery, CompanyForm, StoreForm, DeliveryForm, OtherForm, OtherSettingForm} from './queryConfig/DealerListQuery.js';
    import { dateToTimestamp, timestampToDate, encryption } from '@/utils/index.js';
    import { useI18n } from 'vue-i18n';
    import { useLocale } from '@/store/index.js';   

    const localeStore = useLocale()

    const { t } = useI18n()

    const userInfo = ref({})
    const queryForm = reactive(DealerListQuery)
    const companyForm = reactive(CompanyForm)
    const storeForm = reactive(StoreForm)
    const deliveryForm = reactive(DeliveryForm)
    const otherForm = reactive(OtherForm)
    const otherSettingForm = reactive(OtherSettingForm)
    const detailVisible = ref(false)
    const showForm = ref(false)
    const editVisible = ref(false)
    const levelVisible = ref(false)
    const visibleFile = ref(false)
    const moreVisible = ref(false)
    const rowData = ref(null)
    const showQrcode = ref(false)
    const shortToken = ref('')
    const table = ref({
        datas:[],
        columns:[
            {
                title: '#',
                dataIndex: 'No',
                key:'No',
                width:'60',
                fixed:'left',
                align:'left',
            },
            {
                // title: '公司名称',
                title: t('dealer.companyName'),
                dataIndex: 'company_name',
                key:'company_name',
                width:'200',
                // ellipsis:true,
                // tooltip:true,  
                align:'left',
                fixed:'left'
            },
            {
                // title: '联系人',
                title: t('dealer.contactPerson'),
                dataIndex: 'contact_person',
                key:'contact_person',
                width:'170',
                // ellipsis:true,
                // tooltip:true,  
                align:'left',
            },
            {
                // title: '经销商等级',
                title: t('dealer.level'),
                dataIndex: 'dealer_level',
                key:'dealer_level',
                width:'140',
                ellipsis:true,
                tooltip:true,  
                align:'left',
                slotName:'slot',
            },
            {
                // title: '活跃状态',
                title: t('dealer.isActive2'),
                dataIndex: 'active_flag',
                key:'active_flag',
                width:'100',
                ellipsis:true,
                tooltip:true,  
                align:'left',
                slotName:'slot',
            },
            {
                // title: '支付类型',
                title: t('dealer.paymentType'),
                dataIndex: 'payment',
                key:'payment',
                width:'140',
                ellipsis:true,
                tooltip:true,  
                align:'left',
            },
            {
                // title: '支付天数',
                title: t('dealer.paymentDay'),
                dataIndex: 'payment_day',
                key:'payment_day',
                width:'120',
                ellipsis:true,
                tooltip:true,  
                align:'left',
            },
            {
                // title: 'ERP code',
                title: t('dealer.erpCode'),
                dataIndex: 'erp_code',
                key:'erp_code',
                width:'100',
                ellipsis:true,
                tooltip:true,  
                align:'left',
            },
            {
                // title: 'ERP code',
                title: t('dealer.erpAutoCode'),
                dataIndex: 'auto_code',
                key:'auto_code',
                width:'130',
                ellipsis:true,
                tooltip:true,  
                align:'left',
            },
            {
                // title: '邮箱',
                title: t('dealer.email'),
                dataIndex: 'email',
                key:'email',
                width:'200',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '国家',
                title: t('dealer.country'),
                dataIndex: 'country',
                key:'country',
                width:'110',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                title: t('base.operate'),
                dataIndex: 'Optional',
                key:'Optional',
                slotName:'optional',
                width:'480',
                align:'center',
                fixed:'right'
            }
        ],
        configs:{
            scroll:{
                x:1000,
                y:440,
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:{
                size:'mini',
                current:1,
                pageSize:10,
                total:0,
                pageSizeOptions:[10, 20, 50, 100],
                showJumper:true,
                showPageSize:true,
                showTotal:true,
            },
            
        },
    })
    const copyShareLink = ref('')
    const qrcodeValue = ref('')
    const level = ref('1')
    const exporting = ref(false)
    const levelObj = ref({
        '1':t('dealer.bronze'),
        '3':t('dealer.silver'),
        '5':t('dealer.gold'),
        '7':t('dealer.platinum'),
        '10':'F0/D0',
        '11':'F35/D50',
        '12':'F70/D100',
        '13':'F150/D200',
        '14':'F220/D400',
        '15':'DG1',
        '16':'DG3',
        '17':'DG5',
        '20':'26-DLJB/DCBS400',
        '21':'26-DXXL',
        '22':'26-DV100',
        '23':'26-DV200',
        '24':'26-DV400',
        '25':'26-DG1',
        '26':'26-DG2',
        '27':'26-DG5',
        '28':'26-D0/DB0/DE0/AT0/F0/IT0/N0',
        '29':'26-D50/DB50/DE50AT25/F35/IT25/N25',
        '30':'26-D100/DB100/DE100/AT75/F70/IT75/N75',
        '31':'26-D200/DB200/DE200/AT150/F150/IT150N150',
        '32':'26-D400/DB400/DE400/AT300/F220/IT300/N300',
        '33':'26-N90',
        '34':'26-N150',
        '35':'26-N250',
    })
    const estimate_year = ref('')

    const showFormPanel = (val)=>{
        showForm.value = val
    }

    // 获取完整的级别信息用于tooltip显示
    const getFullLevelInfo = (record) => {
        const levelVal = record.dealer_level_val
        const fullLevelName = levelObj.value[levelVal]
        
        if (!fullLevelName) {
            return record.dealer_level
        }
        
        return `${fullLevelName}`
    }

    // 复制分享链接
    const shareLink = async()=>{
        console.log(window.location,'window.location')
        await getShortToken()
        copy()
    }

    const shareQrcode = async()=>{
        await getShortToken()
        qrcodeValue.value = `${window.location.origin}${window.location.pathname}#/Share?form=share_form&type=qrcode&key=${shortToken.value}`
        showQrcode.value = true
    }

    const copy = ()=>{
        copyShareLink.value = `${window.location.origin}${window.location.pathname}#/Share?form=share_form&type=link&key=${encryption(shortToken.value)}`
        const clipboard = new Clipboard('.shareLink')
        clipboard.on('success',e=>{
            clipboard.destroy()
            Modal.success({
                title: t('base.tip'),
                titleAlign:'start',
                hideCancel:true,
                width:350,
                content: ()=> h('div',{},[
                    h('p',{style:{fontWeight:'bold'}},`${t('dealer.copySuccessFul')}`),
                    h('p',{style:{color:'#f1b223'}},`${t('dealer.copyTip')}`),
                ]),
                okText:t('base.ok'),
            })
        })
        clipboard.on('error',(e)=>{
            clipboard.destroy()
            Message.error(t('base.copyFailed'))
        })
    }

    const previewFile = (file)=>{
        window.open(file)
    }

    const handle = async (type,row)=>{
        switch(type){
            case 'search':
                getDealerList()
                break;
            case 'reset':
                queryForm.formField.forEach(i=>{
                    queryForm.formData[i.key] = ''
                })
                table.value.configs.pagination.current = 1
                getDealerList()
                break;
            case 'reEnter':
                editVisible.value = true
                rowData.value = row

                companyForm.formField.forEach(i=>{
                    companyForm.formData[i.key] = row[i.key] == '-'? '' : row[i.key]
                })
                storeForm.formField.forEach(i=>{
                    storeForm.formData[i.key] = row[i.key] == '-'? '' : row[i.key]
                })
                deliveryForm.formField.forEach(i=>{
                    deliveryForm.formData[i.key] = row[i.key] == '-'? '' : row[i.key]
                })
                otherForm.formField.forEach(i=>{
                    otherForm.formData[i.key] = row[i.key] == '-'? '' : row[i.key]
                })

                getYearEstimateList(row,'reEnter')
                break;
            case 'syncErpCode':
                syncErpCode(row)
                break;
            case 'setLevel':
                level.value = row.dealer_level_val == undefined? '' : row.dealer_level_val
                levelVisible.value = true
                rowData.value = row
                break;
            case 'edit':
                moreVisible.value = true
                rowData.value = JSON.parse(JSON.stringify(row))
                await getYearEstimateList(row)
                otherSettingForm.formData.sale_manager = row.sale_manager
                otherSettingForm.formData.active_flag = row.active_flag_val
                otherSettingForm.formData.test_flag = row.test_flag_val
                otherSettingForm.formData.service_flag = row.service_flag_val
                otherSettingForm.formData.classification = row.classification_val
                otherSettingForm.formData.commitment = row.commitment_val
                otherSettingForm.formData.financial_information = row.financial_information_val
                otherSettingForm.formData.potential = row.potential_val
                otherSettingForm.formData.bico = row.bico_val

                otherSettingForm.formData.vat_no = row.vat_no
                otherSettingForm.formData.contract_signed = row.contract_signed
                otherSettingForm.formData.sales_area_approx = row.sales_area_approx
                otherSettingForm.formData.branches = row.branches
                otherSettingForm.formData.branches_remark = row.branches_remark
                otherSettingForm.formData.service_workshop = row.service_workshop
                otherSettingForm.formData.portfolio = row.portfolio

                otherSettingForm.formField.forEach(i=>{
                    if(i.key == 'estimate'){
                        estimate_year.value = new Date().getFullYear()
                        i.name = `${t('dealer.estimate2')} ${estimate_year.value + 1}:`
                    }
                    if(i.key == 'sales_note'){
                        otherSettingForm.formData.sales_note = row.sales_note_val? row.sales_note_val : ''
                        i.show = otherSettingForm.formData.bico == 'YES'
                    }
                    if(i.key == 'branches_remark'){
                        i.disabled = otherSettingForm.formData.branches == 'NO'
                    }
                })
                break;
            case 'detail':
                getYearEstimateList(row,'detail')
                break;
            case 'exportDealer':
                exportFile()
                break;
        }
    }

    const handleCancelDrawer = ()=>{
        detailVisible.value = false
    }

    const handleSelectChange = (val,item,key)=>{
        table.value.configs.pagination.current = 1
        getDealerList()
    }

    // 列表查询-input
    const handleInputClear = (item, val)=>{
        table.value.configs.pagination.current = 1
        getDealerList()
    }

    const handlePressEnter = (val,item)=>{
        table.value.configs.pagination.current = 1
        getDealerList()
    }

    const changePage = (current)=>{
        table.value.configs.pagination.current = current
        getDealerList()
    }

    const changePageSize = (pageSize)=>{
        table.value.configs.pagination.current = 1
        table.value.configs.pagination.pageSize = pageSize
        getDealerList()
    }

    const changeRadio = (key)=>{
        // console.log(key,'eyyyyy')
        if(key == 'bico'){
            let item = otherSettingForm.formField.find(i=> i.key == 'sales_note')
            otherSettingForm.formData.sales_note = ''
            item.show = otherSettingForm.formData.bico == 'YES'
        }

        if(key == 'branches'){
            let item = otherSettingForm.formField.find(i=> i.key == 'branches_remark')
            item.disabled = otherSettingForm.formData.branches == 'NO'
            otherSettingForm.formData.branches_remark = otherSettingForm.formData.branches == 'NO'? '' : otherSettingForm.formData.branches_remark
        }
    }

    const handleInput = (item,val)=>{
        if(item.key == 'sales_area_approx'){
            otherSettingForm.formData.sales_area_approx = val.replace(/-/g, '')
        }
    }

    const reset = ()=>{
        otherSettingForm.formData.sale_manager = rowData.value.sale_manager
        otherSettingForm.formData.active_flag = rowData.value.active_flag_val
        otherSettingForm.formData.test_flag = rowData.value.test_flag_val
        otherSettingForm.formData.service_flag = rowData.value.service_flag_val

        otherSettingForm.formData.classification = rowData.value.classification_val
        otherSettingForm.formData.commitment = rowData.value.commitment_val
        otherSettingForm.formData.financial_information = rowData.value.financial_information_val
        otherSettingForm.formData.potential = rowData.value.potential_val
        otherSettingForm.formData.bico = rowData.value.bico_val

        otherSettingForm.formData.vat_no = rowData.value.vat_no_val
        otherSettingForm.formData.contract_signed = rowData.value.contract_signed_val
        otherSettingForm.formData.sales_area_approx = rowData.value.sales_area_approx_val
        otherSettingForm.formData.branches = rowData.value.branches_val
        otherSettingForm.formData.branches_remark = rowData.value.branches_remark_val
        otherSettingForm.formData.service_workshop = rowData.value.service_workshop_val
        otherSettingForm.formData.portfolio = rowData.value.portfolio_val

        otherSettingForm.formData.year = rowData.value.year_val
        otherSettingForm.formData.estimate = rowData.value.estimate_val

        let item = otherSettingForm.formField.find(i=> i.key == 'branches_remark')
        item.disabled = otherSettingForm.formData.branches == 'NO'

        // console.log(otherSettingForm.formData,'sssddd')
    }

    const exportFile = async()=>{
        let param = {}
        for(let key in queryForm.formData){
            param[key] = queryForm.formData[key]
        }
        
        Message.success(t('base.exporting'))
        table.value.configs.loading = true
        exporting.value = true
        let res = await DealerApi.getInstance().exportDealer(param)
        if(!res.code){
            let blob = new Blob([res])
            let a = document.createElement('a')
            a.href = URL.createObjectURL(blob)
            a.download = `${t('dealer.exportDealer')}.xlsx`
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            URL.revokeObjectURL(a.href)
            document.body.removeChild(a)
            Message.success(t('base.exportSuccess'))
            exporting.value = false
            table.value.configs.loading = false
        }else{  
            Message.error(res.msg)
        }
    }

    const syncErpCode = async(row)=>{
        let param = {
            erp_code:row.auto_code
        }
        table.value.configs.loading = true
        let res = await DealerApi.getInstance().saveErpCode(param,row.id)
        if(res.code == 0){
            Message.success(t('base.saveSuccess'))
            getDealerList()
        }else{
            Message.error(res.msg)
        }
    }

    // 分享链接，获取临时token
    const getShortToken = async()=>{
        let res = await DealerApi.getInstance().getShortToken()
        if(res.code == 0){
            shortToken.value = res.data
        }else{
            Message.error(res.msg)
        }
    }

    // 获取经销商列表
    const getDealerList = async ()=>{
        let param = {
            ...queryForm.formData,
            email:queryForm.formData.email.trim(),
            // city:queryForm.formData.city.trim(),
        }
        let page_num = table.value.configs.pagination.current
        let page_size = table.value.configs.pagination.pageSize
        table.value.configs.loading = true
        let res = await DealerApi.getInstance().getDealerList(param, page_num, page_size)
        if(res.code == 0){
            res.data.records.forEach((item,index)=>{
                item.No = index + 1
                item.active_flag_val = item.active_flag
                item.test_flag_val = item.test_flag
                item.service_flag_val = item.service_flag
                item.classification_val = item.classification
                item.commitment_val = item.commitment
                item.potential_val = item.potential
                item.bico_val = item.bico
                item.financial_information_val = item.financial_information
                item.sales_note_val = item.sales_note

                item.vat_no_val = item.vat_no
                item.contract_signed_val = item.contract_signed
                item.sales_area_approx_val = item.sales_area_approx
                item.branches_val = item.branches
                item.branches_remark_val = item.branches_remark
                item.service_workshop_val = item.service_workshop
                item.portfolio_val = item.portfolio

                item.active_flag = item.active_flag == 0? t('base.NO') : t('base.YES')

                table.value.columns.forEach(j=>{
                    if(j.key !== 'No' && j.key !== 'Optional'){
                        if(j.key == 'dealer_level'){
                            item.dealer_level_val = item.dealer_level
                            item.dealer_level = item.dealer_level == undefined? '-' :  levelObj.value[item.dealer_level]
                        }else{
                            item[j.key] = !item[j.key]? '-' : item[j.key]
                        } 
                    }
                })
            })
            table.value.datas = res.data.records
            table.value.configs.pagination.total = res.data.total
            table.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    // 经销商评级
    const beforeLevelOk = async (row)=>{
        if(!level.value){
            Message.error(t('dealer.selectLevelTip'))
            return false
        }
        let param = {
            level: level.value
        }
        let res = await DealerApi.getInstance().setLevel(param, rowData.value.id)
        if(res.code == 0){
            Message.success(t('base.setSuccess'))
            getDealerList()
            return true
        }else{
            Message.error(res.msg)
            return false
        }
    }

    // 编辑经销商信息
    const beforeEditOk = async()=>{
        // console.log(companyForm.formData, storeForm.formData, otherForm.formData, deliveryForm.formData)
        if(!companyForm.formData.city){
            Message.error(t('dealer.city') + ' ' + t('base.noEmpty'))
            return false
        }else if(!companyForm.formData.street){
            Message.error(t('dealer.street') + ' ' + t('base.noEmpty'))
            return false
        }else if(!companyForm.formData.zip){
            Message.error(t('dealer.zip') + ' ' + t('base.noEmpty'))
            return false
        }else if(!companyForm.formData.phone){
            Message.error(t('dealer.phone') + ' ' + t('base.noEmpty'))
            return false
        }

        else if(!storeForm.formData.store_city){
            Message.error(t('dealer.storeCity') + ' ' + t('base.noEmpty'))
            return false
        }else if(!storeForm.formData.store_address){
            Message.error(t('dealer.storeAddress') + ' ' + t('base.noEmpty'))
            return false
        }else if(!storeForm.formData.store_zip){
            Message.error(t('dealer.storeZip') + ' ' + t('base.noEmpty'))
            return false
        }else if(!storeForm.formData.store_phone){
            Message.error(t('dealer.storePhone') + ' ' + t('base.noEmpty'))
            return false
        }else if(!storeForm.formData.store_email){
            Message.error(t('dealer.storeEmail') + ' ' + t('base.noEmpty'))
            return false
        }

        else if(!deliveryForm.formData.delivery_city){
            Message.error(t('dealer.deliveryCity') + ' ' + t('base.noEmpty'))
            return false
        }else if(!deliveryForm.formData.delivery_address){
            Message.error(t('dealer.deliveryAddress') + ' ' + t('base.noEmpty'))
            return false
        }else if(!deliveryForm.formData.delivery_zip){
            Message.error(t('dealer.deliveryZip') + ' ' + t('base.noEmpty'))
            return false
        }else if(!deliveryForm.formData.delivery_phone){
            Message.error(t('dealer.deliveryPhone') + ' ' + t('base.noEmpty'))
            return false
        }else if(!deliveryForm.formData.delivery_email){
            Message.error(t('dealer.deliveryEmail') + ' ' + t('base.noEmpty'))
            return false
        }
        
        else if(!otherForm.formData.branches){
            Message.error(t('dealer.branches') + ' ' + t('base.noEmpty'))
            return false
        }else if(!otherForm.formData.service_workshop){
            Message.error(t('dealer.serviceWorkshop') + ' ' + t('base.noEmpty'))
            return false
        }

        let param = {
            id:rowData.value.id,
            company_name:rowData.value.company_name,
            contact_person:rowData.value.contact_person,
            country:rowData.value.country,
            country_code:rowData.value.country_code,
            email:rowData.value.email,
            dealer_level: rowData.value.dealer_level_val,
            ...companyForm.formData,
            ...storeForm.formData,
            ...deliveryForm.formData,
            ...otherForm.formData,

            active_flag: rowData.value.active_flag_val,
            bico: rowData.value.bico_val,
            classification: rowData.value.classification_val,
            commitment: rowData.value.commitment_val,
            financial_information: rowData.value.financial_information_val,
            potential: rowData.value.potential_val,
            sale_manager: rowData.value.sale_manager,
            service_flag: rowData.value.service_flag_val,
            test_flag: rowData.value.test_flag_val,
            dealer_year_ests:[{
                country: rowData.value.yearEstimateList[0].country,
                country_code: rowData.value.yearEstimateList[0].country_code,
                dealer_code: rowData.value.yearEstimateList[0].dealer_code,
                dealer_id: rowData.value.yearEstimateList[0].dealer_id,
                estimate: rowData.value.yearEstimateList[0].estimate,
                year: rowData.value.yearEstimateList[0].year,
            }],

            vat_no: rowData.value.vat_no,
            sales_area_approx: rowData.value.sales_area_approx,
            branches: rowData.value.branches,
            branches_remark: rowData.branches_remark,
            service_workshop: rowData.value.service_workshop,
            portfolio: rowData.value.portfolio,
        }
        console.log(param,'param')

        let res = await DealerApi.getInstance().editDealer(param)
        if(res.code == 0){
            Message.success(t('base.setSuccess'))
            getDealerList()
            return true
        }else{
            Message.error(res.msg)
            return false
        }
    }

    // 编辑经销商其他信息
    const beforeEditOtherOk = async()=>{
        // console.log(otherSettingForm.formData,'mmkk')
        if(
            (otherSettingForm.formData.sale_manager === '' || otherSettingForm.formData.sale_manager === undefined)
            && (otherSettingForm.formData.active_flag === '' || otherSettingForm.formData.active_flag === undefined )
            && (otherSettingForm.formData.test_flag === '' || otherSettingForm.formData.test_flag === undefined )
        ){
            Message.error(t('dealer.editOtherDealerTip'))
            return
        } 

        if(!otherSettingForm.formData.branches){
            Message.error(t('dealer.branches') + ' ' + t('base.noEmpty'))
            return
        }else if(!otherSettingForm.formData.service_workshop){
            Message.error(t('dealer.serviceWorkshop') + ' ' + t('base.noEmpty'))
            return
        }
        // console.log(otherSettingForm.formData,'kkk')

        let form = {}
        otherSettingForm.formField.forEach(i=>{
            if(i.key !== 'estimate'){
                form[i.key] = otherSettingForm.formData[i.key]
            }
        })
        console.log(form,'form')
        let param = {
            id:rowData.value.id,
            ...form,
            dealer_year_ests:[{
                dealer_id:rowData.value.id,
                dealer_code:rowData.value.auto_code,
                country:rowData.value.country,
                country_code:rowData.value.country_code,
                year:!otherSettingForm.formData.estimate? '' : estimate_year.value + 1,
                estimate:otherSettingForm.formData.estimate,
            }]
        }
        console.log(param,'param')
        let res = await DealerApi.getInstance().editDealerOther(param, rowData.value.id)
        if(res.code == 0){
            Message.success(t('base.setSuccess'))
            moreVisible.value = false
            getDealerList()
            return true
        }else{
            Message.error(res.msg)
            return false
        }
    }

    // 获取区域销售经理列表
    const getAreaSaleManagerList = async ()=>{
        let param = {
            dict_code: "dealer", 
            dict_sub_code:'sales_manager',
        }
        let res = await DealerApi.getInstance().getAreaSaleManagerList(param)
        if(res.code == 0){
            let item = otherSettingForm.formField.find(i=> i.key == 'sale_manager')
            let query_item = queryForm.formField.find(i=> i.key == 'sale_manager')
            item.options = []
            query_item.options = []
            res.data.forEach(i=>{
                item.options.push({
                    label:i.dict_sub_name,
                    value:i.dict_sub_value,
                    name:i.dict_sub_name
                })
                query_item.options.push({
                    label:i.dict_sub_name,
                    value:i.dict_sub_value,
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 获取国家下拉配置
    const getCountry = async ()=>{
        let res = await DealerApi.getInstance().getCountry({enable_flag:1})
        if(res.code == 0){
            let item = queryForm.formField.find(i=> i.key == 'country')
            item.options = []
            res.data.forEach(i=>{
                item.options.push({
                    label:i.country,
                    value:i.country
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 获取预测列表
    const getYearEstimateList = async (row, type)=>{
        let year = new Date().getFullYear()
        let param = {
            dealer_id: row.id,
            year: year + 1,
        }
        let res = await DealerApi.getInstance().getYearEstimateList(param)
        if(res.code == 0){
            let data = res.data.length == 0? [] : res.data[res.data.length - 1]
            otherSettingForm.formData.year = data.length == 0? '' : `${data.year}`
            otherSettingForm.formData.estimate = data.length == 0? '' : data.estimate
            
            detailVisible.value = type == 'detail'
            rowData.value = JSON.parse(JSON.stringify(row))
            rowData.value.yearEstimateList = res.data
            rowData.value.year_val = data.length == 0? '' : `${data.year}`
            rowData.value.estimate_val = data.length == 0? '' : data.estimate
            
            let options = otherSettingForm.formField.find(i=> i.key == 'sale_manager').options
            if(!!row.sale_manager){
                let opt = options.find(i=>i.value == row.sale_manager)
                rowData.value.sale_manager_name = opt && opt.name? opt.name : ''
            } 
            console.log(rowData.value,'rowData.value')
        }else{
            Message.error(res.msg)
        }
    }
    
    const resetTableHeight = (clientHeight)=>{
        const headerHeight = document.querySelector('.arco-layout-header').clientHeight
        const breadcrumbHeight = document.querySelector('.arco-page-header-with-breadcrumb').clientHeight
        const searchContentDomHeight = document.querySelector('.queryPanel').clientHeight
        const pageHeight = 60
        const footerHeight = document.querySelector('.footer').clientHeight
        table.value.configs.scroll.y = clientHeight - headerHeight - breadcrumbHeight - searchContentDomHeight - pageHeight - footerHeight - 80
    }

    watch(localeStore,(val)=>{
        resetTableHeight(val.clientHeight)
    })

    onMounted(()=>{
        if(sessionStorage.getItem('userInfo')){
            userInfo.value = JSON.parse(sessionStorage.getItem('userInfo'))
            console.log(userInfo.value.role,'role')

            let item = table.value.columns.find(i=> i.key == 'Optional')
            item.width = userInfo.value.role == '10'? '150' : '300'
        }

        getDealerList()
        getCountry()
        getAreaSaleManagerList()

        nextTick(()=>{
            const clientHeight = document.body.clientHeight
            resetTableHeight(clientHeight)
        })

        sessionStorage.removeItem('toPage')
    })
</script>

<style lang="less" scoped>
.queryPanel{
    display: flex;
    // margin-bottom:7px;
    padding:7px;
    background: #fff;
    border-bottom: 1px dashed #ccc;

    .queryPanel_form{
        display: flex;
        flex:6;
        flex-direction: column;
        height: 33px;
        overflow: hidden;

        /deep/ .arco-form-layout-inline .arco-form-item{
            margin-bottom:0;
        }
    }

    .queryPanel_form_show{
        height: auto;
        overflow: visible;
    }

    .queryPanel_btn{
        display: flex;
        // flex-direction: column;
        // flex-wrap:wrap;
        flex: 1;
        align-items: center;
        justify-content: center;
        border-left:1px solid #eee;
        padding-left:10px;

        .openBtn{
            display: inline-block;
            padding: 3px 10px;
            margin: 2px 5px 0 5px;
            width: 80px;
            text-align: center;
            color: #165dff;
            cursor: pointer;
            border: 1px solid #165dff;
            border-radius:2px;
        }
    }

    /deep/ .arco-form-item-label-col > .arco-form-item-label{
        font-size:12px;
    }

    /deep/ .arco-form-item-layout-inline{
        margin-right: 0;
    }

    .form_btn{
        margin:5px 5px 3px;
        width:90px;
    }
}

/deep/ .operayeBox {
    margin-bottom: 7px;
    background: #fff;
    padding: 5px 24px 5px;
}

/deep/ .arco-btn-group{
    vertical-align: bottom;
}
/deep/ .arco-btn-group .arco-btn:first-child,
/deep/ .arco-btn-group .arco-btn:last-child{
    background: #165dff;
    color: #fff;
}

/deep/ .arco-table-th{
    background: #fff;
    border-bottom: 1px solid #eee;
    border-right: 1px solid #eee;
    // padding: 10px 0;
    font-size: 12px;
    font-weight: 600;
}

/deep/ .arco-table-td{
    padding: 0;
    font-size: 12px;
    // border-bottom: none;
    border-right: 1px solid #eee;
}

/deep/ .arco-table-container{
    padding-bottom:0;
}

/deep/ .arco-picker-size-medium input,
/deep/ .arco-input-wrapper .arco-input.arco-input-size-medium,
/deep/ .arco-select-view-single.arco-select-view-size-medium .arco-select-view-input{
    font-size:12px;
}

/deep/ .arco-pagination-options .arco-select,
/deep/ .arco-pagination-jumper .arco-pagination-jumper-input input{
    background: #e7e7e7;
}

/deep/  button:focus,
/deep/  button:focus-visible{
    outline: none;
}

.editInfo{
    display: inline-block;
    margin: 0 20px 5px 0;
    color: #4392fa;
}

/deep/ .arco-modal-body{
    text-align: center;
}

.qrcode{
    position: relative;
}

.logo{
    position: absolute;
    top: 25%;
    left:50%;
    margin-left: -12px;
    background: #fff;
    padding: 4px 6px 0;
    border-radius: 5px;
}

/deep/ .arco-btn-size-mini{
    height: 20px;
    margin: 0 2px;
    padding: 5px 3px;
    font-size: 11px;
}

.editHead{
    display: inline-block;
    margin-right: 40px;
}

// 经销商级别选择容器
.dealer-level-container {
    text-align: left;
    max-height: 400px;
    overflow-y: auto;
    padding: 20px 10px;
}

// 经销商级别选择组网格布局
.dealer-level-radio-group {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px 20px;
    
    .radioItem {
        margin-bottom: 0;
        width: 100%;
        min-width: 300px;
        
        /deep/ .arco-radio {
            display: flex;
            align-items: flex-start;
            width: 100%;
            
            .arco-radio-icon {
                margin-top: 2px;
                margin-right: 8px;
                flex-shrink: 0;
            }
            
            .arco-radio-label {
                flex: 1;
                font-size: 13px;
                color: #333;
                line-height: 1.5;
                white-space: normal;
                word-wrap: break-word;
                overflow: visible;
                text-overflow: initial;
                max-width: none;
                padding: 0;
            }
        }
        
        &:hover {
            /deep/ .arco-radio .arco-radio-label {
                color: #165dff;
                font-weight: 500;
            }
        }
    }
}

/deep/ .arco-radio-icon::after{
    top: 0px;
    left: 0px;
}

/deep/ .arco-radio-checked .arco-radio-icon::after{
    transform: scale(0.5);
}

// 级别标签悬停效果
.level-tag-hover {
    cursor: pointer;
    transition: all 0.2s ease;
    
    &:hover {
        transform: scale(1.05);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    }
}

</style>